<card [isFullCard]="true">
  <div class="swagger-docs-display" id="swaggerDoc"></div>
</card>
